var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page flex-center"},[_c('p',{staticClass:"font-size-60 font-color-264480 font-bold"},[_vm._v("404")]),_c('p',{staticClass:"font-size-30 font-color-264480"},[_vm._v("页面不见了")])])
}]

export { render, staticRenderFns }